import React, { useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
// import "./CalendarComponent.css"; // custom styles

const CalendarComponent = () => {
  const [date, setDate] = useState(new Date());

  const onChange = (newDate) => {
    setDate(newDate);
  };

  return (
    <div className="calendar-container">
      {/* <h2 className="calendar-header">My Calendar</h2> */}
      <Calendar
        onChange={onChange}
        value={date}
        className="custom-calendar"
        tileClassName={({ date, view }) => {
          // Add custom class to specific dates
          if (date.getDate() === new Date().getDate()) {
            return "highlight";
          }
        }}
      />
    </div>
  );
};

export default CalendarComponent;
